module.exports = __webpack_public_path__ + "img/finance_pay_oil_off.4c5ef4fe.png";